import React from "react";
import useCreateCompanyStore from "../../stores/createCompanyStore";
import WelcomePage from "./WelcomePage";
import CompanyNamePage from "./CompanyNamePage";
import StartingModulesPage from "./StartingModulesPage";
import UserDetailsPage from "./UserDetailsPage";
// import DepartmentsPage from "./DepartmentsPage";
import ConfirmationPage from "./ConfirmationPage";
import CompanyCreatedPage from "./CompanyCreatedPage";

// Index of the final "company created" page in the wizard.
const COMPANY_CREATED_STEP = 5;

function CreateNewCompanyDisplay(props) {
  const {
    currentStep,
    formData,
    resetForm,
    setFormData,
  } = useCreateCompanyStore();

  const handleBackToLogin = () => {
    const shouldShowOnboarding = currentStep === COMPANY_CREATED_STEP;
    const adminEmail = formData.email;

    resetForm();
    if (shouldShowOnboarding) {
      setFormData('email', adminEmail);
      setFormData('setupCompleted', true);
    }
    props.onBack();
  };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 0:
        return <WelcomePage />;
      case 1:
        return <CompanyNamePage />;
      case 2:
        return <StartingModulesPage />;
      case 3:
        return <UserDetailsPage />;
      case 4:
        return <ConfirmationPage />;
      // case 5:
      //   return <DepartmentsPage />;
      case COMPANY_CREATED_STEP:
        return (
          <CompanyCreatedPage
            onBackToLogin={handleBackToLogin}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="relative">
      {/* Back to home link - positioned absolutely */}
      {currentStep !== COMPANY_CREATED_STEP && (
        <div className="absolute top-4 left-4 z-10">
          <div
            onClick={handleBackToLogin}
            className="inline-flex items-center px-3 py-2 text-sm text-gray-600 hover:text-gray-900 rounded-lg shadow-sm hover:shadow-md transition-all duration-200 cursor-pointer"
          >
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back to Login
          </div>
        </div>
      )}

      {/* Form content */}
      {renderCurrentStep()}
    </div>
  );
}

export default CreateNewCompanyDisplay;
